import React, { useState } from "react";
import  Button  from "../../Components/ui/button";
import Right from '../../Images/RightSvg.svg'
import EasyOfficeLogo from '../../Images/New/Products/easyOffice.webp'
import EasyGstLogo from '../../Images/New/Products/easyGst.webp'
import EO1 from "../../Images/New/OtherProducts/EO/1.gif";
import EO2 from "../../Images/New/OtherProducts/EO/2.gif";
import EO3 from "../../Images/New/OtherProducts/EO/3.gif";
import EO4 from "../../Images/New/OtherProducts/EO/4.gif";
import EO5 from "../../Images/New/OtherProducts/EO/5.gif";
import EO6 from "../../Images/New/OtherProducts/EO/6.gif";
import EO7 from "../../Images/New/OtherProducts/EO/7.gif";
import EO8 from "../../Images/New/OtherProducts/EO/8.gif";
import EA1 from "../../Images/New/OtherProducts/EA/1.gif";
import EA2 from "../../Images/New/OtherProducts/EA/2.gif";
import EA3 from "../../Images/New/OtherProducts/EA/3.gif";
import EA4 from "../../Images/New/OtherProducts/EA/4.gif";
import EA5 from "../../Images/New/OtherProducts/EA/5.gif";
import EA6 from "../../Images/New/OtherProducts/EA/6.gif";
import EA7 from "../../Images/New/OtherProducts/EA/7.gif";
import EA8 from "../../Images/New/OtherProducts/EA/8.gif";

const OtherProduct = () => {

  const [isExpanded1, setIsExpanded1] = useState(false);

  const toggleExpand1 = () => {
    setIsExpanded1(!isExpanded1);
  };

  const [isExpanded2, setIsExpanded2] = useState(false);

  const toggleExpand2 = () => {
    setIsExpanded2(!isExpanded2);
  };
  

  return (
    <>
      <div className="w-full sm:py-20 sm:pr-10 p-3 relative bg-[#ffffff] flex justify-center">
        <div className="w-full max-w-7xl">
          <div className="text-center mb-5">
            <p className="text-5xl text-black font-bold">
              Our Software Product<span className="text-[#00aacc]">'s</span>
            </p>
          </div>
          <div className="flex flex-col-reverse sm:flex-row justify-evenly w-full items-center bg-[#ffffff] py-4 border-2 border-[#00aacc] rounded-2xl mb-12">
            <div className="sm:w-1/2 sm:p-0 pt-4 flex justify-center items-center">
              {/* <img
                src={EasyOfficeBG}
                className="sm:w-[60%] sm:p-5 p-3 border-2 border-[#519980] rounded-2xl shadow-2xl hover:shadow-none"
                alt=""
              /> */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-5 pr-8">
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Quick ITR Upload
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    TDS & TCS Returns
                  </p>
                </div>

                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    e-Audit Report
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Balance Sheet
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    CMA Data Preparation
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Online Tax Payment
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Multiangle Analysis Reports
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EO8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Office Management Utilities
                  </p>
                </div>
              </div>
            </div>
            <div className="sm:w-1/2 px-3 sm:px-0">
              <div className="pr-12">
                {/* <p className="mb-5 text-[#000000] text-3xl font-bold">
                  EasyOFFICE
                </p> */}
                <img
                  src={EasyOfficeLogo}
                  alt="EasyOffice Logo"
                  className="w-[30%] mb-5 mt-2"
                />
                <p className="mb-3 text-[#000000] text-xl font-bold">
                  Powerful & Preferred Taxation Software with the Best Price
                </p>
                <p className="mb-0 text-black font-medium text-lg">
                  EasyOFFICE is an integrated Taxation Software with the motto
                  of Complete Office Management for Chartered Accountants (CA),
                  Tax Professionals and Tax Advocates. This flagship product is
                  a bundle of many software modules & utilities like Income Tax
                  Software (EasyTax), TDS software (EasyTDS), Audit Report &
                  Balance Sheet software (EasyAudit), CMA Data software
                  (EasyCMA), Office Management Utilities & more.
                </p>
                {isExpanded1 && (
                  <div>
                    <p className="my-3 text-black font-medium text-lg">
                      EasyOFFICE Tax return filing software is exclusively
                      designed and developed as per the system specified by the
                      Income Tax Department of India, Protean and TRACES.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      EasyOFFICE India’s Top Tax Return filing software also
                      offers Multiple other features like Back up, Restore,
                      EasyForm, MyInvoice, User Data Access Management, XML /
                      JSON file import & many more. Calculating your income and
                      tax liability, self-assessment tax, advance tax, Arrears,
                      26AS / AIS / TIS data direct Import and interest as per
                      sections 234A, 234B, 234C & 234F has been made simple with
                      EasyTAX software. All such features, Accuracy &
                      user-friendly operation makes EasyOFFICE as Best Income
                      Tax Software among tax professionals in India.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      EasyAUDIT software incorporates various forms such as 3CA,
                      3CB, 3CD, 3CEB, 29B, 10B allows the preparation of audit
                      reports & account statements as per Tax Audit and Company
                      audit Schedules. EasyAudit is the Preferred choice among
                      CA’s for audit report efiling. Managing TDS quarterly
                      e-Return for 24Q, 26Q, 27Q, 27EQ, TDS Correction, Data
                      Import options, Interest calculation, Online data
                      automation tools & Multiple analysis reports makes it the
                      Best TDS Return filing software. EasyCMA is the best
                      software for preparing and calculating CMA Data.
                    </p>
                    <p className="mb-3 text-black font-medium text-lg">
                      The software's return filing capability is a key feature
                      that streamlines the tax preparation and filing process,
                      ensuring accuracy and compliance with the latest
                      regulations. With its robust features and Powerful user
                      interface, Electrocom's EasyOFFICE - A Complete Taxation
                      Software is a trusted solution and valuable asset for
                      professionals seeking to optimize their tax preparation &
                      filing processes with ease.EasyOffice Software demo can be
                      downloaded free of cost.
                    </p>
                  </div>
                )}
                <button onClick={toggleExpand1} className="mt-2 cursor-pointer">
                  {isExpanded1 ? "Show Less" : "Show More"}
                </button>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Income Tax Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Balance Sheet Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      TDS Return Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      CMA Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Audit e-filing Software
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Office Utilities
                    </p>
                  </div>
                </div>
              </div>
              <div className="sm:flex grid grid-cols-1 mt-5">
                <a
                  href="https://www.easyofficesoftware.com/public/demo/demo/EasyOfficeDemoSetup.exe"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3"
                >
                  <div className="">
                    <Button label={"Download Demo"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyOFFICE-CATALOGUE.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"Catalogue"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/easyofficesoftware"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"View More"} />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-evenly w-full items-center bg-[#ffffff] py-4 border-2 border-[#00aacc] rounded-2xl">
            <div className="sm:w-1/2 p-3 sm:pl-20">
              <div className="">
                {/* <p className="mb-5 text-[#000000] text-3xl font-bold">
                  EasyACC
                </p> */}
                <img
                  src={EasyGstLogo}
                  alt="EasyAccLogo"
                  className="w-[35%] mb-5"
                />
                <p className="mb-3 text-[#000000] text-xl font-bold">
                  Simplify GST Return filing & Reconciliation with EasyGST
                  Software
                </p>
                <p className="mb-0 text-[#000000] text-lg font-medium">
                  EasyGST is one of the best Goods and Services tax software for
                  Chartered Accountants (CA), Tax professionals & businesses in
                  India for the easiest GST return filing. EasyGST is developed
                  to make GST related workflow quick, smooth & accurate.
                  Experience the power of simplified GST compliance with EasyGST
                  Software's free demo download!
                </p>
                {isExpanded2 && (
                  <div>
                    <p className="my-3 text-black text-lg font-medium">
                      EasyGST software supports direct uploading of GST returns,
                      reconciliation module for GSTR 2A, GSTR 2B with accounts,
                      MIS reports and analysis, data backup & restore, verifying
                      bulk GSTIN and simplifying GST management with the
                      comprehensive Dashboard. It further helps to track ITC
                      (Input Tax Credit) match/mismatch for invoice
                      reconciliation. It prepares & file GST returns such as
                      GSTR 1, GSTR 3B, GSTR 4, GST CMP 08, GSTR 7, GSTR 9, GSTR
                      9C, etc. with ease.
                    </p>
                    <p className="mb-3 text-black text-lg font-medium">
                      EasyGST return filing software provides a single-window
                      dashboard design with access to all the necessary features
                      and tax filing capabilities with easy and user-friendly
                      operations. This return filing software is exclusively
                      designed and developed as per GST guidelines.
                    </p>
                  </div>
                )}
                <button onClick={toggleExpand2} className="mt-2 cursor-pointer">
                  {isExpanded2 ? "Show Less" : "Show More"}
                </button>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Single Window dashboard
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Return Statistics
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      E-Invoice & E-way Bill
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      Online Activities
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Import from Tally & Excel
                    </p>
                  </div>
                  <div className="flex">
                    <img src={Right} alt="" />
                    <p className="mb-0 text-lg font-semibold ml-1 text-black">
                      {" "}
                      Verify Bulk GSTIN
                    </p>
                  </div>
                </div>
              </div>
              <div className="sm:flex grid grid-cols-1 mt-5">
                <a
                  href="https://www.easyofficesoftware.com/public/demo/demo/EasyGSTDemoSetup.exe"
                  target="_blank"
                  rel="noreferrer"
                  className=" mt-3"
                >
                  <div className="">
                    <Button label={"Download Demo"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyGST-CATALOGUE.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"Catalogue"} />
                  </div>
                </a>
                <a
                  href="https://www.easyofficesoftware.com/easygst"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-3 mt-3"
                >
                  <div className="">
                    <Button label={"View More"} />
                  </div>
                </a>
              </div>
            </div>
            <div className="sm:w-1/2 p-3 sm:p-0 flex justify-center items-center">
              {/* <img
                src={EasyAccBG}
                className="sm:w-[60%] sm:p-5 p-3 border-2 border-[#519980] rounded-2xl shadow-2xl hover:shadow-none"
                alt=""
              /> */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 px-3 sm:px-5 sm:pr-8">
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    GST Returns e-filing
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Data Import & Export
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    ITC Reconciliation <br />
                    with Accounts
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Annual Return & <br />
                    Audit Report
                  </p>
                </div>

                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Comprehensive <br />
                    Dashboard
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Online Data link <br />
                    with GST portal
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Multi-Angle Data <br />
                    Analysis & Reports
                  </p>
                </div>
                <div className="bg-white flex items-center border-2 border-[#00aacc] py-2 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={EA7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Pre-validation to <br />
                    rectify errors
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherProduct;
